import { ConnectionPositionPair } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { HrAssistantAnalyticsService } from '@core/intelligence-logic';
import { HrAssistantTriggerComponent } from '@core/intelligence-ui';
import { ConnectedOverlayDirective, OverlayOriginDirective } from '@core/user-interface-legacy';

import { HrAssistantService } from './hr-assistant.service';
import { HrAssistantChatComponent } from '../hr-assistant-chat/hr-assistant-chat.component';

@Component({
  selector: 'hr-assistant',
  imports: [
    HrAssistantTriggerComponent,
    HrAssistantChatComponent,
    ConnectedOverlayDirective,
    OverlayOriginDirective,
  ],
  templateUrl: './hr-assistant.component.html',
  styleUrl: './hr-assistant.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HrAssistantComponent {
  private readonly hrAssistantService = inject(HrAssistantService);
  private readonly hrAssistantAnalytics = inject(HrAssistantAnalyticsService);

  protected readonly positions = [
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
    },
  ] satisfies ConnectionPositionPair[];
  protected readonly offsetY = -20;
  protected readonly offsetX = 0;
  protected readonly userData = this.hrAssistantService.userData;

  protected assistantEnabled = toSignal(this.hrAssistantService.assistantEnabled$);
  protected assistantEntitled = this.hrAssistantService.assistantEntitled;
  protected assistantSettings = this.hrAssistantService.assistantSettings;

  public ngOnInit() {
    this.hrAssistantService.openWalkthrough();
  }

  public trackTriggerClick() {
    this.hrAssistantAnalytics.trackTriggerClick();
  }
}
